import { useQuery } from "@tanstack/react-query"
import { createPublicClient, http } from "viem"
import { mainnet } from "viem/chains"
import { useAccount } from "wagmi"

import { selectIsConnected, useDappSelector } from "#/redux-state"

import {
  ONE_MINUTE_IN_SECONDS,
  ONE_SECOND_IN_MILLISECONDS,
  queryKeysFactory,
  RPC_URL_ETHEREUM,
} from "../../constants"
import AugustVault from "../../constants/artifacts/AugustVault"
// TODO: remove this file once we release the Mezo Vaults.

const publicClient = createPublicClient({
  // The contracts for the vault are deployed only on ethereum.
  chain: mainnet,
  transport: http(RPC_URL_ETHEREUM),
})

const refetchInterval = ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS * 5
const staleTime = refetchInterval

export const useEthVaultStats = () => {
  const { data, ...rest } = useQuery({
    queryKey: queryKeysFactory.mezoKeys.vaultStats(),
    queryFn: async () => {
      const totalAssets = await publicClient.readContract({
        abi: AugustVault.abi,
        address: AugustVault.address,
        functionName: "totalAssets",
      })

      return totalAssets
    },
    refetchInterval,
    staleTime,
  })

  return { stats: { totalDeposited: data }, ...rest }
}

export const useEthVaultPosition = () => {
  const isConnected = useDappSelector(selectIsConnected)
  const { address } = useAccount()

  const { data, ...reset } = useQuery({
    queryKey: [...queryKeysFactory.userKeys.vaultPosition(), address],
    queryFn: async () => {
      const shares = await publicClient.readContract({
        abi: AugustVault.abi,
        address: AugustVault.address,
        functionName: "balanceOf",
        args: [address!],
      })

      return shares
    },
    refetchInterval,
    staleTime,
    enabled: !!address && isConnected,
  })

  return { position: { shares: data }, ...reset }
}
